// customerApi.ts
import axios from '../api/axiosSetup3';
import { Customer } from '../contexts/CustomerContext';

// export interface Customer {
//   customer_id: number;
//   legal_name: string;
//   name: string;
//   email?: string;
//   phone?: string;
// }

const getEntities = async (param: {tenant_id: string, mode: string}): Promise<Customer[]> => {
    const res = await axios.get('/v_entity0?order=customer_id');
    if (Array.isArray(res.data)) {
    return res.data.map((row: any) => ({
        ...row,
        name: `${row.customer_id} - ${row.name}`
    }));
    } else {
        return [];
    }
    return res.data;
};

const get = async (param: {tenant_id: string, mode: string}): Promise<Customer[]> => {
    const res = await axios.get(`/v_customer?tenant_id=eq.${param.tenant_id}&mode=eq.${param.mode}&order=customer_id`, {
        headers: {
            'Accept-Profile': 'public' // schema
        }        
    });
    return res.data.map((row: any) => ({
        ...row,
        name: row.legal_name
    }));
};

// const getUserCacheId = async (userId: number, tenantId: string, mode: string): Promise<{id: number}> => {
//     const res = await axios.get(`/user_cache?user_id=eq.${userId}&tenant_id=eq.${tenantId}&mode=eq.${mode}`, {
//         headers: {
//             'Accept-Profile': 'public' // schema
//         }        
//     });
//     return res.data[0].id;
// };

// const updateUserCache = async (customer: Customer, userId: number, tenantId: string, mode: string): Promise<boolean> => {
//     const id = await getUserCacheId(userId, tenantId, mode);
//     const res = await axios.patch(`user_cache?id=eq.${id}`, { customer_id: customer.customer_id }, {
//         headers: {
//             'Content-Profile': 'public' // schema
//         }        
//     });
//     return res.status === 204;
// }

const patch = async (customer_id: number, field: string, value: string): Promise<boolean> => {
    let payload: any = {};
    payload[field] = value;
    const res = await axios.patch(`customer?customer_id=eq.${customer_id}`, payload, { 
        headers: {
            'Content-Profile': 'public' // schema
        }        
    });
    return res.status === 204;
}

const getCustomer = async (customer_id: number, ): Promise<Customer[]> => {
    const res = await axios.get(`customer?customer_id=eq.${customer_id}`, { 
        headers: {
            'Accept-Profile': 'public' // schema
        }        
    });
    return res.data;
}

const stopUserService = async (customer_id: number, userId: number): Promise<boolean> => {
    const tenantId = import.meta.env.DEV ?
      import.meta.env.VITE_USERFRONT_TENANT_ID_TEST : 
      import.meta.env.VITE_USERFRONT_TENANT_ID_LIVE;

    const apiKey = import.meta.env.DEV ?
      import.meta.env.VITE_USERFRONT_API_KEY_TEST : 
      import.meta.env.VITE_USERFRONT_API_KEY_LIVE;

    const response = await fetch(
        `https://api.userfront.com/v0/tenants/${tenantId}/users/${userId}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiKey}`,
            },
            body: JSON.stringify({
                // "isLocked": true
                // "active": false
                data: { "banned": true }
            }),
        }
    );
    if (!response.ok) {
        const errorDetail = await response.json();
        console.log("Детали ошибки:", errorDetail);
    }

    const data = await response.json();
    console.log('data', data);
    
    const res = await axios.post('rpc/sf_stop_service', {customer_id}, );
    return true;
}

const stopService = async (customer_id: number): Promise<boolean> => {
    const res = await axios.post('rpc/sf_stop_service', {customer_id}, );
    return true;
}

const changeCustomer = async (customer_id: number): Promise<boolean> => {
    const res = await axios.post('https://avto.aipeeper.com/api/identity/dj_user/', {customer_id}, );
    return res.status === 200;
}

export const api = {
    notused_get: get,
    getEntities,
    changeCustomer,
    patch,
    getCustomer,
    stopService,
    stopUserService,
};
